// extracted by mini-css-extract-plugin
export default {"spinner":"Animation_spinner__EtRhb"};